// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import TranslationOfTextContentResourceViewModel from '../../../../viewModel/resource/TranslationOfTextContentResourceViewModel';
import TextContentResourceViewModel from '../../../../viewModel/resource/TextContentResourceViewModel';
import TextContentResourceDTO from '../../dto/resource/TextContentResourceDTO';

export default abstract class TextContentResourceModel extends BaseModel<TextContentResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  */
  get textContentKey() { return this.dto.textContentKey; }
  set textContentKey(value) { this.dto.textContentKey = value; }
  /**
  */
  get scope() { return this.dto.scope; }
  set scope(value) { this.dto.scope = value; }
  /**
  */
  get originalContent() { return this.dto.originalContent; }
  set originalContent(value) { this.dto.originalContent = value; }
  /**
  */
  get originalLanguage() { return this.dto.originalLanguage; }
  set originalLanguage(value) { this.dto.originalLanguage = value; }
  /**
  */
  get translations() { return this.getArrayModels(() => this.dto.translations, TranslationOfTextContentResourceViewModel)!; }
  set translations(value) { this.setArrayModels(() => this.dto.translations, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    this.dto.textContentKey = qs.textcontentkey;
    this.dto.scope = qs.scope;
    this.dto.originalContent = qs.originalcontent;
    this.dto.originalLanguage = qs.originallanguage;
  }
}
